import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import React, { useState, useContext } from "react";

import NavBar from "./Navbar";
import TopBar from "./TopBar";
import SettingsContext from "../../context/SettingsContext";
import TypeWrapper from "../../utils/TypeWrapper";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    overflow: "hidden",
    width: "100%",
    backgroundColor: TypeWrapper.COLORS.BG_DSHBRD_LAYOUT,
    position: "relative",
  },
  root1: {
    backgroundColor: TypeWrapper.COLORS.BG_DSHBRD_LAYOUT,
    position: "relative",
    // height: "100vh", // 19 Nov Commented
  },
  wrapper1: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    overflow: "hidden",
    position: "relative",
    minHeight: "calc(100vh - 75px)",
    // paddingLeft: 256, // Sidebar width on large screens
    transition: "padding-left 0.3s ease",
    [theme.breakpoints.down("lg")]: {
      paddingLeft: 0,
    },
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    overflow: "hidden",
    position: "relative",
    backgroundColor: TypeWrapper.COLORS.HX_WHITE,
    paddingTop: 70,
    minHeight: "calc(100vh - 75px)",
    transition: "padding-left 0.3s ease",
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 230,
    },
  },
  sidebar: {
    width: 230,
    transition: "width 0.3s ease",
    height: "100vh",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 1000,
    [theme.breakpoints.down("lg")]: {
      width: 0,
      transition: "width 0.3s ease",
    },
  },
  contentContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    overflow: "hidden",
    paddingTop: 75,
  },
  content: {
    flex: "1 1 auto",
    height: "100%",
    overflow: "hidden",
    position: "relative",
    padding: "20px",
    marginLeft: 230,
    transition: "margin-left 0.3s ease",
    "@media (max-width: 1280px)": {
      padding: "10px 20px",
    },
    [theme.breakpoints.down("md")]: {
      marginLeft: 0,
    },
    [theme.breakpoints.down("xs")]: {
      padding: "10px 24px 10px ",
    },
  },
}));

const DashboardLayout = ({ children }) => {
  const classes = useStyles();
  const themeSeeting = useContext(SettingsContext);

  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div
      className={
        themeSeeting.settings.theme === "DARK"
          ? `${classes.root1}`
          : `${classes.root}`
      }
    >
      {/* ****** Topbar Container ****** */}
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />

      {/* ****** Sidebar & Content Container ****** */}
      <div
        className={
          themeSeeting.settings.theme === "DARK"
            ? `${classes.wrapper1}`
            : `${classes.wrapper}`
        }
      >
        {/* ****** Sidebar Container ****** */}
        <div
          className={classes.sidebar}
          style={{
            width: isSidebarOpen ? "230px" : "0", // Toggle sidebar width based on state
            transition: "width 0.3s ease",
          }}
        >
          <NavBar
            onMobileClose={() => setMobileNavOpen(false)}
            openMobile={isMobileNavOpen}
            isSidebarOpen={isSidebarOpen} // Pass sidebar state to NavBar
            toggleSidebar={() => setSidebarOpen(!isSidebarOpen)} // Toggle sidebar visibility
          />
        </div>

        {/* ****** Content Container ****** */}
        <div
          className={classes.contentContainer}
          style={{ paddingTop: isSidebarOpen ? 100 : 100 }}
        >
          <div className={classes.content} id="main-scroll">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
